import appStore from '@/store';
import { ArticleEditMode } from '@/@types/ArticleEditMode';

export const dispatchOpenArticleEditor = (articleId: string, mode?: ArticleEditMode) => {
  // const _mode = mode || (article.isTextArticle() ? ArticleEditMode.NOTES : ArticleEditMode.VIDEO);
  return appStore.dispatch('openArticleEditor', { articleId, mode });
};

export const dispatchAutosaveArticle = () => {
  return appStore.dispatch('articleEditorAutosaveArticle');
};

export const dispatchSaveArticle = (isPublish: boolean, isNotification: boolean) => {
  return appStore.dispatch('articleEditorSaveArticle', { isPublish, isNotification });
};
